/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Navbar
 */

import { Container, Nav, Navbar } from 'react-bootstrap';

// Hooks
import ToogleHeaderStyle from './toogleHeaderStyle';

// Logo
import logo from '../../../assets/img/logo.svg';

// Styles
import './style.scss';

const NavBar = (props) => {
    const links = props.links;

    const headerStyle = ToogleHeaderStyle();

    const createNavItem = ({ href, text, spyid }) => (
        <Nav.Item key={href}>
            <Nav.Link
                href={href}
                data-to-scrollspy-id={spyid}
            >
                {text}
            </Nav.Link>
        </Nav.Item>
    );

    return (
        <Navbar
            collapseOnSelect
            expand="lg"
            fixed="top"
            // bg="transparent"
            // variant="light"
            className={headerStyle}
        >
            <Container>
                <Navbar.Brand href="/">
                    <img
                        src={logo}
                        width="140"
                        height="60"
                        className="d-inline-block align-top"
                        alt="BeeCaramulo Apiturismo"
                    />
                </Navbar.Brand>

                <Navbar.Toggle />
                
                <Navbar.Collapse className="justify-content-end">
                    <Nav>
                        {links.map(createNavItem)}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}
export default NavBar;